// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1V5c1","colBig":"styles_colBig__KqzRS","colSmall":"styles_colSmall__2cN_d"};